import * as actions from './actionConstants';

export const getDivisions = () => ({
  type: actions.GET_DIVISIONS,
});

export const getDivisionsSuccess = (divisionsList, parentDivisionsList, divisions) => ({
  type: actions.GET_DIVISIONS_SUCCESS,
  divisionsList,
  parentDivisionsList,
  divisions,
});

export const getDivisionsError = error => ({
  type: actions.GET_DIVISIONS_ERROR,
  error,
});

export const getSeasonDivisions = (seasonId) => ({
  type: actions.GET_SEASON_DIVISIONS,
  seasonId
});

export const getSeasonDivisionsSuccess = (divisionsList, divisions) => ({
  type: actions.GET_SEASON_DIVISIONS_SUCCESS,
  divisionsList,
  divisions,
});

export const getSeasonDivisionsError = error => ({
  type: actions.GET_SEASON_DIVISIONS_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/actions/divisionsActions.js